import { render, staticRenderFns } from "./HomeVersions.vue?vue&type=template&id=bcaa6d4e&"
import script from "./HomeVersions.vue?vue&type=script&lang=js&"
export * from "./HomeVersions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports